export const SERVICE_CODE = 'DEAL' + '_DAS' + '_SERVICE';
